import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _ec63a17a = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "" */))
const _6dab2d20 = () => interopDefault(import('../pages/authorization/index.vue' /* webpackChunkName: "pages/authorization/index" */))
const _603635f1 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _2427dbaf = () => interopDefault(import('../pages/partner/index.vue' /* webpackChunkName: "pages/partner/index" */))
const _9658b960 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _32d1ca48 = () => interopDefault(import('../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _5297eba8 = () => interopDefault(import('../pages/request-password/index.vue' /* webpackChunkName: "pages/request-password/index" */))
const _3be97f77 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _2794d423 = () => interopDefault(import('../pages/success-payment/index.vue' /* webpackChunkName: "pages/success-payment/index" */))
const _1b647bc4 = () => interopDefault(import('../pages/partner/activations-history/index.vue' /* webpackChunkName: "pages/partner/activations-history/index" */))
const _c25f6ec6 = () => interopDefault(import('../pages/partner/price-regulator/index.vue' /* webpackChunkName: "pages/partner/price-regulator/index" */))
const _0d777a3c = () => interopDefault(import('../pages/partner/sim-card/index.vue' /* webpackChunkName: "pages/partner/sim-card/index" */))
const _cd48b920 = () => interopDefault(import('../pages/partner/statistic/index.vue' /* webpackChunkName: "pages/partner/statistic/index" */))
const _3d44e02c = () => interopDefault(import('../pages/partner/withdrawal-funds/index.vue' /* webpackChunkName: "pages/partner/withdrawal-funds/index" */))
const _659544d6 = () => interopDefault(import('../pages/profile/history/index.vue' /* webpackChunkName: "pages/profile/history/index" */))
const _5fcee3be = () => interopDefault(import('../pages/profile/loyalty-program/index.vue' /* webpackChunkName: "pages/profile/loyalty-program/index" */))
const _577383a9 = () => interopDefault(import('../pages/profile/pay/index.vue' /* webpackChunkName: "pages/profile/pay/index" */))
const _cf4c736e = () => interopDefault(import('../pages/profile/referral-program/index.vue' /* webpackChunkName: "pages/profile/referral-program/index" */))
const _9e536c78 = () => interopDefault(import('../pages/profile/referral-program-soft/index.vue' /* webpackChunkName: "pages/profile/referral-program-soft/index" */))
const _1e4e1079 = () => interopDefault(import('../pages/profile/sale-agreement/index.vue' /* webpackChunkName: "pages/profile/sale-agreement/index" */))
const _671a3558 = () => interopDefault(import('../pages/profile/settings/index.vue' /* webpackChunkName: "pages/profile/settings/index" */))
const _7304dbd8 = () => interopDefault(import('../pages/profile/statistics/index.vue' /* webpackChunkName: "pages/profile/statistics/index" */))
const _3dee9710 = () => interopDefault(import('../pages/profile/tariffs/index.vue' /* webpackChunkName: "pages/profile/tariffs/index" */))
const _782c38e4 = () => interopDefault(import('../pages/signup/confirm-email.vue' /* webpackChunkName: "pages/signup/confirm-email" */))
const _5e7f94a9 = () => interopDefault(import('../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _ca91c8d4 = () => interopDefault(import('../pages/bot-link/_link.vue' /* webpackChunkName: "pages/bot-link/_link" */))
const _710fbcf5 = () => interopDefault(import('../pages/confirm/_token.vue' /* webpackChunkName: "pages/confirm/_token" */))
const _184e6928 = () => interopDefault(import('../pages/countries/_.vue' /* webpackChunkName: "pages/countries/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/ru",
    components: {
      default: _ec63a17a
    },
    name: "index___ru"
  }, {
    path: "/cn",
    components: {
      default: _ec63a17a
    },
    name: "index___cn"
  }, {
    path: "/tr",
    components: {
      default: _ec63a17a
    },
    name: "index___tr"
  }, {
    path: "/es",
    components: {
      default: _ec63a17a
    },
    name: "index___es"
  }, {
    path: "/hi",
    components: {
      default: _ec63a17a
    },
    name: "index___hi"
  }, {
    path: "/ar",
    components: {
      default: _ec63a17a
    },
    name: "index___ar"
  }, {
    path: "/authorization",
    component: _6dab2d20,
    pathToRegexpOptions: {"strict":true},
    name: "authorization"
  }, {
    path: "/blog",
    component: _603635f1,
    pathToRegexpOptions: {"strict":true},
    name: "blog"
  }, {
    path: "/partner",
    component: _2427dbaf,
    pathToRegexpOptions: {"strict":true},
    name: "partner"
  }, {
    path: "/profile",
    component: _9658b960,
    pathToRegexpOptions: {"strict":true},
    name: "profile"
  }, {
    path: "/registration",
    component: _32d1ca48,
    pathToRegexpOptions: {"strict":true},
    name: "registration"
  }, {
    path: "/request-password",
    component: _5297eba8,
    pathToRegexpOptions: {"strict":true},
    name: "request-password"
  }, {
    path: "/search",
    component: _3be97f77,
    pathToRegexpOptions: {"strict":true},
    name: "search"
  }, {
    path: "/success-payment",
    component: _2794d423,
    pathToRegexpOptions: {"strict":true},
    name: "success-payment"
  }, {
    path: "/partner/activations-history",
    component: _1b647bc4,
    pathToRegexpOptions: {"strict":true},
    name: "partner-activations-history"
  }, {
    path: "/partner/price-regulator",
    component: _c25f6ec6,
    pathToRegexpOptions: {"strict":true},
    name: "partner-price-regulator"
  }, {
    path: "/partner/sim-card",
    component: _0d777a3c,
    pathToRegexpOptions: {"strict":true},
    name: "partner-sim-card"
  }, {
    path: "/partner/statistic",
    component: _cd48b920,
    pathToRegexpOptions: {"strict":true},
    name: "partner-statistic"
  }, {
    path: "/partner/withdrawal-funds",
    component: _3d44e02c,
    pathToRegexpOptions: {"strict":true},
    name: "partner-withdrawal-funds"
  }, {
    path: "/profile/history",
    component: _659544d6,
    pathToRegexpOptions: {"strict":true},
    name: "profile-history"
  }, {
    path: "/profile/loyalty-program",
    component: _5fcee3be,
    pathToRegexpOptions: {"strict":true},
    name: "profile-loyalty-program"
  }, {
    path: "/profile/pay",
    component: _577383a9,
    pathToRegexpOptions: {"strict":true},
    name: "profile-pay"
  }, {
    path: "/profile/referral-program",
    component: _cf4c736e,
    pathToRegexpOptions: {"strict":true},
    name: "profile-referral-program"
  }, {
    path: "/profile/referral-program-soft",
    component: _9e536c78,
    pathToRegexpOptions: {"strict":true},
    name: "profile-referral-program-soft"
  }, {
    path: "/profile/sale-agreement",
    component: _1e4e1079,
    pathToRegexpOptions: {"strict":true},
    name: "profile-sale-agreement"
  }, {
    path: "/profile/settings",
    component: _671a3558,
    pathToRegexpOptions: {"strict":true},
    name: "profile-settings"
  }, {
    path: "/profile/statistics",
    component: _7304dbd8,
    pathToRegexpOptions: {"strict":true},
    name: "profile-statistics"
  }, {
    path: "/profile/tariffs",
    component: _3dee9710,
    pathToRegexpOptions: {"strict":true},
    name: "profile-tariffs"
  }, {
    path: "/signup/confirm-email",
    component: _782c38e4,
    pathToRegexpOptions: {"strict":true},
    name: "signup-confirm-email"
  }, {
    path: "/blog/:slug",
    component: _5e7f94a9,
    pathToRegexpOptions: {"strict":true},
    name: "blog-slug"
  }, {
    path: "/bot-link/:link?",
    component: _ca91c8d4,
    pathToRegexpOptions: {"strict":true},
    name: "bot-link-link"
  }, {
    path: "/confirm/:token?",
    component: _710fbcf5,
    pathToRegexpOptions: {"strict":true},
    name: "confirm-token"
  }, {
    path: "/countries/*",
    component: _184e6928,
    pathToRegexpOptions: {"strict":true},
    name: "countries-all"
  }, {
    path: "/*",
    component: _ec63a17a,
    pathToRegexpOptions: {"strict":true},
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
